// ประมาณจำนวน token เมื่อ engine ไม่ส่ง usage กลับมา (ไทย ~1 token ต่อ 1.6 ตัวอักษร, อังกฤษ ~4 ตัวอักษร)
export function estimateTokens(text) {
  const s = String(text || "");
  if (!s) return 0;
  const thai = (s.match(/[฀-๿]/g) || []).length;
  return Math.max(1, Math.ceil(thai / 1.6 + (s.length - thai) / 4));
}
